import DeleteIcon from '@mui/icons-material/Delete';
import { styled } from '@mui/system';
import { theme } from '../../lib/index';

export const ClearAllFilters = styled(DeleteIcon, {})({
  justifySelf: 'flex-end',

  opacity: 0.8,
  margin: '10px 20px',

  color: theme.palette.placeholdergrey,
  fontSize: 30,

  transition: 'opacity 250ms ease-in-out',

  cursor: 'pointer',

  '&:hover': {
    opacity: 0.6,

    transition: 'opacity 250ms ease-in-out',
  },
});
